import clsx from "clsx"
import { Laptop, User } from "iconoir-react"

import { ProctoringStep } from "../index"

interface ProctoredTimelineProps {
  step: ProctoringStep
}

const ProctoredTimeline = ({ step }: ProctoredTimelineProps) => {
  return (
    <div className="relative order-2 hidden w-auto flex-col items-center justify-center gap-1 bg-transparent px-4 py-20 lg:order-none lg:flex">
      <div className="absolute inset-y-0 left-1/2 w-px -translate-x-1/2 bg-onSurface-200" />

      {/* Step 1 Icon */}
      <div
        className={clsx(
          "relative z-10 flex size-8 items-center justify-center rounded-full border-2 transition-colors",
          step >= ProctoringStep.SYSTEM_CHECK
            ? "border-black-500 bg-white text-black-600"
            : "border-onSurface-200 bg-surface-50 text-onSurface-300"
        )}
      >
        <Laptop className="size-4" />
      </div>

      <div className="h-16 w-px" />
      {/* Spacer */}

      {/* Step 2 Icon */}
      <div
        className={clsx(
          "relative z-10 flex size-8 items-center justify-center rounded-full border-2 transition-colors",
          step >= ProctoringStep.FACE_CAPTURE
            ? "border-black-500 bg-white text-black-600"
            : "border-onSurface-200 bg-surface-50 text-onSurface-300"
        )}
      >
        <User className="size-4" />
      </div>
    </div>
  )
}

export default ProctoredTimeline
